import { render, staticRenderFns } from "./supported-ecommerce-list.vue?vue&type=template&id=43f9747a"
var script = {}
import style0 from "./supported-ecommerce-list.vue?vue&type=style&index=0&id=43f9747a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports